export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_FORMAT_DASH = 'DD-MM-YYYY'
export const DATE_FORMAT_DASH_REVERSED = 'YYYY-MM-DD'
export const TIME_FORMAT = 'HH:mm'

export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`

export const TIME_DELAY = 1
export const AD_PACKAGE_TIME_DELAY = 0
